module.exports = __webpack_public_path__ + "static/tony-ba0af53588a41e99dd501f9262a786ad.jpg";